const endpoint = "https://api.openai.com/v1/chat/completions";  // Use the appropriate endpoint for your desired model.
const scrambled = ["sk", "-", "svcacct","-", "i4THn1qxJ18sYOQJhRJLRH2wiTTxp1kx2_nQwzyeJtY4cyRpF16A3iv-6u7I3kDXqPNjVNpsRhT3BlbkFJmGpLTOFc-llkrsv0AutTgfauJQ5l0AcHyMNlZBPffbddq29MDb5n9vduzlaTrl3AZ4AcYl_usA"].join("");

const code_to_use = scrambled;
export default async function make_call(history, onMessageChunk) {
   
    const response = await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${code_to_use}`
        },
        body: JSON.stringify({
            messages: [
                { role: "system", content: "You are an assistant designed to help diagnose culture trends and findings, based on a large amount of qualitative feedback." },
                ...history
            ],
            model: 'o3-mini',
            stream: true // Enable streaming
        })
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let done = false;
    let assistantMessage = ""; // Collect assistant's response

    while (!done) {
        const { value, done: readerDone } = await reader.read();
        done = readerDone;
        const chunk = decoder.decode(value, { stream: true });

        // Split the stream by lines and parse each one
        const lines = chunk.split("\n").filter(line => line.trim());
        for (const line of lines) {
            if (line === "data: [DONE]") {
                done = true; // End the stream on [DONE]
                break;
            }
            if (line.startsWith("data: ")) {
                try {
                    const json = JSON.parse(line.replace("data: ", ""));
                    if (json.choices && json.choices[0].delta.content) {
                        const content = json.choices[0].delta.content;
                        onMessageChunk(content); // Stream to UI
                        assistantMessage += content; // Append to assistant's response
                    }
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                }
            }
        }
    }


    return assistantMessage.trim();
}